<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Filter payments and refunds</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="filter()">
        <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>

<ion-content>

  <ion-grid class="form">
    <ion-row>
      <ion-col>
        <ion-grid class="fieldset">

          <ion-row>
            <ion-col>
              <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="timeframe_options" (ionCancel)="clearTimeframe()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['timeframe']">
                <div slot="label">Timeframe<ion-text class="optional">optional</ion-text></div>
                <ion-select-option value="today">Today</ion-select-option>
                <ion-select-option value="yesterday">Yesterday</ion-select-option>
                <ion-select-option value="this_week">This week (Mon-Sun)</ion-select-option>
                <ion-select-option value="last_week">Last week (Mon-Sun)</ion-select-option>
                <ion-select-option value="this_month">This month</ion-select-option>
                <ion-select-option value="last_month">Last month</ion-select-option>
                <ion-select-option value="custom">Custom</ion-select-option>
              </ion-select>
            </ion-col>
          </ion-row>

          @if (filter_params['timeframe'] == 'custom') {
            <ion-row>
              <ion-col size="6">
                @if (filter_params['date_from'] && filter_params['date_from'].length != 0) {
                  <ion-input class="modal-input" readonly="true" label="From date" labelPlacement="stacked" fill="outline" value={{formatted_date_from}} (click)="presentFromDateTimePickerModal()"></ion-input>
                }
                @if (!filter_params['date_from'] || filter_params['date_from'].length == 0) {
                  <ion-input class="modal-input" readonly="true" label="From date" labelPlacement="stacked" fill="outline" (click)="presentFromDateTimePickerModal()"></ion-input>
                }
              </ion-col>
              <ion-col size="6">
                @if (filter_params['date_to'] && filter_params['date_to'].length != 0) {
                  <ion-input class="modal-input" readonly="true" label="To date" labelPlacement="stacked" fill="outline" value={{formatted_date_to}} (click)="presentToDateTimePickerModal()"></ion-input>
                }
                @if (!filter_params['date_to'] || filter_params['date_to'].length == 0) {
                  <ion-input class="modal-input" readonly="true" label="To date" labelPlacement="stacked" fill="outline" (click)="presentToDateTimePickerModal()"></ion-input>
                }
              </ion-col>
            </ion-row>
          }

          <ion-row>
            <ion-col>
              <ion-select cancelText="Cancel" okText="OK" interface="alert" label="Currency" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['currency_id']">
                @for (currency of supported_currencies; track currency) {
                  <ion-select-option value="{{currency.id}}">{{currency.title}}</ion-select-option>
                }
              </ion-select>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col>
              <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="method_options" (ionCancel)="clearMethod()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['method']">
                <div slot="label">Method<ion-text class="optional">optional</ion-text></div>
                <ion-select-option value="afterpay">Afterpay</ion-select-option>
                <ion-select-option value="bank_transfer">Bank transfer</ion-select-option>
                <ion-select-option value="cash">Cash</ion-select-option>
                <ion-select-option value="cheque">Cheque</ion-select-option>
                <ion-select-option value="credit_card">Credit card</ion-select-option>
                <ion-select-option value="custom">Custom</ion-select-option>
                <ion-select-option value="eftpos">EFTPOS</ion-select-option>
                <ion-select-option value="external_card">External card</ion-select-option>
                <ion-select-option value="gift_voucher">Gift voucher</ion-select-option>
                <ion-select-option value="laybuy">Laybuy</ion-select-option>
                <ion-select-option value="organisation_store_credit">Organisation store credit</ion-select-option>
                <ion-select-option value="paypal">PayPal</ion-select-option>
                <ion-select-option value="person_store_credit">Person store credit</ion-select-option>
                <ion-select-option value="poli">POLi</ion-select-option>
              </ion-select>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>

</ion-content>